import { render, staticRenderFns } from "./platformCategoryList.vue?vue&type=template&id=ac4ac916&scoped=true"
import script from "./platformCategoryList.vue?vue&type=script&lang=js"
export * from "./platformCategoryList.vue?vue&type=script&lang=js"
import style0 from "./platformCategoryList.vue?vue&type=style&index=0&id=ac4ac916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4ac916",
  null
  
)

export default component.exports